/* src/app/modules_v2/finance/bank-account/components/bank-account-detail/bank-account-detail.component.scss */
:host {
  display: block;
}
.ba-panel {
  display: grid;
  grid-template-columns: minmax(260px, 1fr) minmax(0, 1.4fr);
  gap: 16px;
}
.ba-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 14px 16px;
  min-width: 0;
}
.ba-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}
.ba-card__title,
.ba-block__title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 700;
  color: #1a1d23;
}
.ba-card__title mat-icon,
.ba-block__title mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  color: #6b7280;
}
.ba-lines {
  display: flex;
  flex-direction: column;
  border: 1px solid #eef1f4;
  border-radius: 8px;
  overflow: hidden;
}
.ba-line {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 7px 12px;
  font-size: 13px;
  color: #2f3540;
}
.ba-line + .ba-line {
  border-top: 1px solid #eef1f4;
}
.ba-line__label {
  color: #6b7280;
  white-space: nowrap;
}
.ba-line__value {
  font-weight: 600;
  text-align: right;
  min-width: 0;
  overflow-wrap: anywhere;
}
.ba-line__value--mono {
  font-family:
    ui-monospace,
    SFMono-Regular,
    Menlo,
    Consolas,
    monospace;
  font-size: 12px;
}
.ba-kpis {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  margin-top: 12px;
}
.ba-kpi {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  padding: 8px 10px;
  background: #f4f6f8;
  border-radius: 8px;
  min-width: 0;
}
.ba-kpi--accent {
  background: #fbfee8;
  border: 1px solid #e5f3a0;
}
.ba-kpi__label {
  font-size: 11px;
  color: #6b7280;
}
.ba-kpi__value {
  font-size: 14px;
  font-weight: 700;
  color: #1a1d23;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.ba-block {
  padding: 10px 0;
}
.ba-block + .ba-block {
  border-top: 1px solid #eef1f4;
}
.ba-block__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 8px;
}
.ba-block__summary {
  font-size: 12px;
  color: #6b7280;
  white-space: nowrap;
}
.ba-block__summary strong {
  color: #1a1d23;
  font-variant-numeric: tabular-nums;
}
.ba-moves {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.ba-block__side {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}
.ba-add.cf-btn.mat-mdc-button-base {
  height: 28px !important;
  padding: 0 10px !important;
  font-size: 12px !important;
}
.ba-add.cf-btn.mat-mdc-button-base .mat-icon {
  font-size: 16px !important;
  width: 16px !important;
  height: 16px !important;
  margin-right: 2px !important;
}
.ba-move {
  display: grid;
  grid-template-columns: 90px minmax(0, 1fr) auto auto;
  align-items: center;
  gap: 10px;
  padding: 6px 6px 6px 10px;
  background: #f9fafb;
  border: 1px solid #eef1f4;
  border-radius: 6px;
  font-size: 13px;
  transition: border-color 0.15s ease, background 0.15s ease;
}
.ba-move:hover {
  background: #fff;
  border-color: #e5e7eb;
}
.ba-move__date {
  color: #6b7280;
  white-space: nowrap;
}
.ba-move__info {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.ba-move__concept,
.ba-move__meta {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ba-move__concept {
  color: #2f3540;
}
.ba-move__meta {
  font-size: 11px;
  color: #6b7280;
}
.ba-move__amount {
  font-weight: 700;
  color: #1a1d23;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.ba-move__actions {
  display: flex;
  align-items: center;
  gap: 2px;
}
.ba-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #9ca3af;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}
.ba-icon-btn mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.ba-icon-btn:hover {
  background: #f3f4f6;
  color: #1a1d23;
}
.ba-icon-btn--danger:hover {
  background: #fef2f2;
  color: #dc2626;
}
.ba-more {
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  gap: 2px;
  margin-top: 2px;
  padding: 2px 6px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  font-size: 12px;
  font-weight: 600;
  color: #4b5563;
  cursor: pointer;
}
.ba-more mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}
.ba-more:hover {
  background: #f3f4f6;
  color: #1a1d23;
}
.ba-block__empty {
  font-size: 12px;
  color: #9ca3af;
  padding: 2px 0;
}
.ba-empty {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  padding: 12px 14px;
  background: #f9fafb;
  border: 1px dashed #e5e7eb;
  border-radius: 8px;
  font-size: 13px;
  color: #6b7280;
}
.ba-empty mat-icon {
  flex-shrink: 0;
  font-size: 20px;
  width: 20px;
  height: 20px;
}
.ba-empty--error mat-icon {
  color: #dc2626;
}
@media (max-width: 900px) {
  .ba-panel {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 480px) {
  .ba-kpis {
    grid-template-columns: 1fr;
  }
  .ba-move {
    grid-template-columns: minmax(0, 1fr) auto auto;
  }
  .ba-move__date {
    grid-column: 1/-1;
  }
}
/*# sourceMappingURL=bank-account-detail.component.css.map */
